import { styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";

const StyledHeadCell = styled(TableCell)(({ theme }) => ({
  padding: "5px 8px",
  fontSize: "12px",
  lineHeight: "1.0rem",
}));

export default StyledHeadCell;